import {Axios} from "axios";
import {UserDto} from "../user/User";
import {PersonFilterDto} from "../person/PersonApiClient";
import {PageableResultListDto} from "../pagination/PageableResultListDto";
import {PageableDto} from "../pagination/PagingFilterDto";
import {SortableDto} from "../pagination/SortingFilterDto";

export interface FormSessionCreateDto {
    documentType?: string;
    documentVersion?: string;
    openerParams?: Record<string, string>;
}

export interface FormSessionDto {
    id: number;
    createdAt?: string;
    documentType?: string;
    documentVersion?: string;
    user?: UserDto;
    submissionId?: number;
    state?: FormSessionStateType;
}

export enum FormSessionStateType {
    CREATED = "CREATED",
    OBTAINING_PREFILL_INFORMATION = "OBTAINING_PREFILL_INFORMATION",
    OBTAINING_INFORMATION_FAILED = "OBTAINING_INFORMATION_FAILED",
    PREFILL_INFORMATION_OBTAINED = "PREFILL_INFORMATION_OBTAINED",
    OPEN = "OPEN",
    SENT = "SENT",
    EXPIRED = "EXPIRED",
}

export interface FormSessionFilterDto extends PageableDto, SortableDto {
    createdAtFrom?: string;
    createdAtTo?: string;
    documentTypes?: string[];
    person?: PersonFilterDto;
    submissionId?: number;
}

export interface FormSessionCreateResultDto {
    formSession: FormSessionDto;
    prefillRequests: FormSessionPrefillRequestDto[];
    redirectUrl: string;
}

export enum FormSessionPrefillRequestStateType {
    IN_PROGRESS = "IN_PROGRESS",
    OBTAINED = "OBTAINED",
    FAILED = "FAILED",
}

export interface FormSessionPrefillRequestDto {
    id?: string;
    formSessionId?: number;
    informationSystem?: String;
    informationDetail?: String;
    state?: FormSessionPrefillRequestStateType;
    required?: boolean;
}

export class FormSessionApiClient {

    constructor(private readonly axios: Axios) {
    }

    findByFilter(filter: FormSessionFilterDto): Promise<PageableResultListDto<FormSessionDto>> {
        return new Promise((resolve, reject) => {
            this.axios.post<PageableResultListDto<FormSessionDto>>("/form-sessions:search", filter)
                .then((response) => resolve(response.data))
                .catch((error) => reject(error));
        });
    }

    countByFilter(filter: FormSessionFilterDto): Promise<number> {
        return new Promise((resolve, reject) => {
            this.axios.post<number>("/form-sessions:count", filter)
                .then((response) => resolve(response.data))
                .catch((error) => reject(error));
        });
    }

    createSessionAndReturnRedirectInfo(create: FormSessionCreateDto): Promise<FormSessionCreateResultDto> {
        return new Promise((resolve, reject) => {
            this.axios.post<FormSessionCreateResultDto>(`/form-sessions`, create)
                .then((response) => resolve(response.data))
                .catch((error) => reject(error));
        });
    }

    findFormSessionPrefillRequests(formSessionId: number): Promise<FormSessionPrefillRequestDto[]> {
        return new Promise((resolve, reject) => {
            this.axios.get<FormSessionPrefillRequestDto[]>(`/form-sessions/${formSessionId}/prefill-requests`)
                .then((response) => resolve(response.data))
                .catch((error) => reject(error));
        });
    }

    findById(formSessionId: number): Promise<FormSessionDto> {
        return new Promise((resolve, reject) => {
            this.axios.get<FormSessionDto>(`/form-sessions/${formSessionId}`)
                .then((response) => resolve(response.data))
                .catch((error) => reject(error));
        });
    }
}
